/* eslint-disable max-len */
import { useCallback } from 'react';
import log from '~/helpers/log';

export default function useDetectMicrophone() {
  const setMicrophone = useCallback(async () => {
    try {
      const mic = await navigator.mediaDevices.getUserMedia(
        { audio: true, video: false },
        stream => {
          if (stream) {
            log.info('Accessed the Microphone');
          }
        },
        err => {
          log.error('The following error occured:', err);
        }
      );

      if (mic.active) {
        // close microphone
        mic.getTracks().forEach(track => track.stop());
        return true;
      }
      return false;
    } catch (err) {
      log.error('Failed to get avaiable microphones.', err);
      return false;
    }
  }, []);

  return setMicrophone;
}
